import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group form-check" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  type: "button",
  class: "btn btn-primary btn-lg",
  disabled: ""
}
const _hoisted_11 = {
  key: 1,
  class: "container"
}
const _hoisted_12 = { class: "fg-color-blue" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import ValidationError from '@common/Components/ValidationError.vue'
    import { useCurrentUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useCreateUserCommandV1 } from '@Organizations/Users/commands-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUserPage',
  setup(__props) {

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    // ---------------- local state ----------------

    const email = ref('')
    const firstName = ref('')
    const lastName = ref('')
    const password = ref('')
    const passwordConfirmation = ref('')
    const setInitialPassword = ref(false)

    // ---------------- validation ----------------

    const passwordConfirmationInvalid = computed(() =>
    {
        if (!setInitialPassword.value) return false
        return !!passwordConfirmation.value && passwordConfirmation.value !== password.value
    })

    const { runCurrentUserQueryV1 } =
        useCurrentUserQueryV1(false, false, true)

    // ---------------- command ----------------

    const {
        invokeCreateUserCommandV1,
        invokingCreateUserCommandV1,
        validationErrors,
        succeedCreateUserCommandV1,
        errorCreateUserCommandV1
    } = useCreateUserCommandV1(
        '0',
        tid,
        email,
        firstName,
        lastName,
        false,
        false,
        false,
        true,
        setInitialPassword,
        password
    )

    const userCreated = computed(() => succeedCreateUserCommandV1.value === true)

    onMounted(() =>
    {
        document.title = 'Create a new user'
        runCurrentUserQueryV1()
    })

    // ---------------- handlers ----------------

    function handleCreateUserCommandV1()
    {
        if (passwordConfirmationInvalid.value) return
        invokeCreateUserCommandV1()
    }

    function handleFinish()
    {
        email.value = ''
        firstName.value = ''
        lastName.value = ''
        password.value = ''
        passwordConfirmation.value = ''
        setInitialPassword.value = false
    }

    // ---------------- error handling ----------------

    watch(errorCreateUserCommandV1, (err) =>
    {
        if (err)
        {
            alert(err)
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Create a new user</h1></div><div class=\"col-lg-5 col-sm-6 text-right\"></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (!userCreated.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "Email" }, "Email:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              type: "email",
              class: "form-control",
              placeholder: "Work email of an user"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, email.value]
            ]),
            _createVNode(ValidationError, {
              context: "Email",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "FirstName" }, "First name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
              type: "text",
              class: "form-control",
              placeholder: "First name of an user"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, firstName.value]
            ]),
            _createVNode(ValidationError, {
              context: "FirstName",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "LastName" }, "Last name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Last name of an user"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, lastName.value]
            ]),
            _createVNode(ValidationError, {
              context: "LastName",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((setInitialPassword).value = $event)),
              type: "checkbox",
              class: "form-check-input",
              id: "setInitialPassword"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, setInitialPassword.value]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              class: "form-check-label",
              for: "setInitialPassword"
            }, "Set initial password manually", -1 /* CACHED */))
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "Password" }, "Initial password:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event)),
                type: "password",
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, password.value]
              ]),
              _createVNode(ValidationError, {
                context: "Password",
                errors: _unref(validationErrors)
              }, null, 8 /* PROPS */, ["errors"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { for: "PasswordConfirmation" }, "Initial password confirmation:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((passwordConfirmation).value = $event)),
                type: "password",
                class: _normalizeClass(["form-control", { 'is-invalid': passwordConfirmationInvalid.value }])
              }, null, 2 /* CLASS */), [
                [_vModelText, passwordConfirmation.value]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "invalid-feedback" }, "Initial password confirmation doesn't match", -1 /* CACHED */))
            ], 512 /* NEED_PATCH */), [
              [_vShow, password.value]
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, setInitialPassword.value]
          ]),
          (!_unref(invokingCreateUserCommandV1))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: handleCreateUserCommandV1,
                type: "button",
                class: "btn btn-primary btn-lg",
                disabled: passwordConfirmationInvalid.value
              }, "Create", 8 /* PROPS */, _hoisted_9))
            : (_openBlock(), _createElementBlock("button", _hoisted_10, "Creating..."))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("h4", _hoisted_12, "User was created and initial system generated password was sent on " + _toDisplayString(email.value), 1 /* TEXT */),
          _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/manage/type/${email.value}`,
            class: "btn btn-success text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("i", {
              class: "fa fa-external-link",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("span", null, "Manage user roles", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_13),
          _cache[17] || (_cache[17] = _createElementVNode("h4", {
            class: "fg-color-blue",
            style: {"margin":"20px 0"}
          }, "or", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/manage/workspaces/${email.value}`,
            class: "btn btn-secondary text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[14] || (_cache[14] = [
            _createElementVNode("i", {
              class: "fa fa-external-link",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("span", null, "Manage user workspaces", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_14),
          _cache[18] || (_cache[18] = _createElementVNode("h4", {
            class: "fg-color-blue",
            style: {"margin":"20px 0"}
          }, "or", -1 /* CACHED */)),
          _createElementVNode("button", {
            onClick: handleFinish,
            class: "btn btn-secondary text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("i", {
              class: "fa fa-user-plus",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("span", null, "Add another user", -1 /* CACHED */)
          ]))])
        ]))
  ]))
}
}

})